<template>
  <div class="myProfile">
    <van-nav-bar
      class="nav_bar"
      title="我的资料"
      left-arrow
      placeholder
      @click-left="onClickLeft"
    />
    <van-nav-bar class="space_nav_bar" />
    <junminPersonal/>
  </div>
</template>

<script>
import junminPersonal  from './editProfile'
console.log(junminPersonal,'-----------------')
export default {
  name: "myProfile",
  data() {
    return {
      haveSavedDetailFlag: false, //判断是否保存过
    }
  },
  components:{
    junminPersonal
  },
  mounted(){
    sessionStorage.setItem('myProfile','myProfile')
    if(localStorage.getItem('token')){
      this.getData();
    }
  },
  methods: {
    //获取详情
    getData() {
      this.$api.usercenter.findUser().then((res) => {
        if (res.code == 0 && res.success) {
          if(res.data.areaCode && res.data.userIdentity && res.data.extra?.project){
            this.haveSavedDetailFlag = true;
          }else{
            this.haveSavedDetailFlag = false;
          }
        }
      });
    },
    onClickLeft() {
      if(this.haveSavedDetailFlag){
        this.$router.go(-1);
      }else{
        this.$notify({ duration: 3000,type: 'danger', message: '请先完善个人必填信息' })
      }
    }
  }
}
</script>

<style lang="stylus">
.myProfile {
  
  .nav_bar {
    position: fixed !important;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 10;
  }

  .space_nav_bar {
    background-color: transparent !important;
  }

  // .van-cell {
  //   min-height: 2.773rem;
  //   padding-left: 0.8rem;
  //   padding-right: 0.8rem;
  //   display: flex;
  //   align-items: center;
  // }

  // .van-field__label {
  //   width: 5.33rem;
  // }

  // .van-cell.photo_wrap {
  //   align-items: flex-start;
  //   padding-top: 0.96rem;
  //   padding-bottom: 1.066rem;
  // }
}
</style>